export default __webpack_public_path__ + "static/media/manila.16485fa4.png";